import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import useClickAway from "@/core/helpers/useClickAway";
import { CrossIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  estateId: number;
  estateType: EstateType;
  address: string;
};

export default function EstateSetResidentModal({
  onClose,
  onConfirm,
  estateId,
  estateType,
  address,
  isLoading,
}: Props) {
  const { t } = useTranslation("estate");
  const ref = useClickAway(onClose);

  return (
    <div
      className={clsx(
        "absolute z-10 top-0 left-0 right-0 bottom-0 bg-[#0F0F0F]/95",
        "flex items-center justify-center",
        "animate-[--animation-fade-in]",
      )}
    >
      {isLoading && (
        <div className="flex items-center justify-center p-4">
          <div className="mz-loader" />
        </div>
      )}

      {!isLoading && (
        <div
          ref={ref}
          className={clsx(
            "w-[25.25rem] p-5 bg-gradient-to-b from-[#0F0F0F] to-[#0F0F0F]/90 rounded-[0.875rem]",
            "relative p-7.5 flex flex-col items-center greenShadow",
          )}
        >
          <Button
            variant="soft"
            color="gray"
            className="absolute top-2.5 right-2.5 w-[1.875rem] h-[1.875rem] p-0"
            onClick={onClose}
          >
            <CrossIcon size={12} />
          </Button>
          <div className="text-18 font-bold text-white">
            {t(`estate.type.${estateType}.name`)} #{estateId}
          </div>
          <div className="text-15 font-medium text-white/70 mt-1">{address}</div>
          <div className="h-[1px] w-[20rem] bg-[#1F1F1F]/80 flex justify-center my-5">
            <div className="h-full w-[5rem] bg-[#84FF97]" />
          </div>
          <div className="text-16 font-medium text-white">
            {t("estate.resident.confirm", { address })}
          </div>
          <div className="w-full flex items-center gap-2.5 mt-2.5" data-mz-accent="success">
            <Button className="h-[2.625rem] basis-[50%]" onClick={onConfirm}>
              {t("estate.yes")}
            </Button>
            <Button
              variant="solid-surface-gradient"
              className="h-[2.625rem] basis-[50%]"
              onClick={onClose}
            >
              {t("estate.cancel")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
